<template>
  <div class="user-info-wrapper">
    <van-image class="bg" :src="value.mobile_background || bg" />
    <div class="brief-info">
      <van-image round width="50" height="50" fit="cover" class="avatar" :src="value.avatar" />
      <div class="member_card">
        <span>昵称：{{ value.nickname }}</span>
        <span>会员码：{{ value.member_card }}</span>
      </div>
    </div>
    <div class="balance-info">
      <span>余额：<i>￥</i>{{ value.credit2 }}</span>
      <van-button color="#42BCFF" size="small" @click.stop="onPay">充值开卡</van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bg: 'https://whk.imqhd.com/images/bg.jpg',
    };
  },
  methods: {
    onPay() {
      this.$emit('pay');
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-wrapper {
  height: 250px;
  position: relative;
  width: 100%;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .bg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 250px;
    z-index: -1;
    opacity: 0.5;
  }
  .brief-info {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    text-shadow: 0 0 5px #000;
    .member_card {
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .balance-info {
    background-color: #fff;
    box-shadow: 0 0 5px #aaa;
    border-radius: 6px;
    text-align: center;
    margin: 0 16px;
    padding: 16px 10px;
    display: flex;
    justify-content: space-around;
    span {
      line-height: 24px;
      i {
        font-size: 12px;
      }
    }
    .van-button {
      min-width: 44px;
      height: 24px;
      line-height: 22px;
    }
  }
}
</style>
